import { downloadFile } from '@/util/file';
import { CrossIcon, DownloadIcon } from '../../Svg/IconV2';

type ARCapturePreviewProps = {
  img: string;
  onClose: () => void;
};
const ARCapturePreview = ({ img, onClose }: ARCapturePreviewProps) => {
  return (
    <div className="absolute m-auto inset-0 w-fit h-[60%] border-2 rounded-[12px] border-white z-[11]">
      <img
        src={img}
        className="object-cover h-full w-auto rounded-[12px] m-auto"
        alt=""
      />
      <div className="relative h-full w-full flex justify-center items-center">
        <div className="flex flex-row gap-12 absolute top-4">
          <div className="" onClick={() => downloadFile(img)}>
            <DownloadIcon size={25} />
          </div>

          <div className="cursor-pointer" onClick={onClose}>
            <CrossIcon size={20} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ARCapturePreview;
